import { gql } from '@apollo/client';

export const BULK_RESEND_INVITATION_MUTATION = gql`
  mutation resendInvitations($invitationIds: [Int]!) {
    invitation {
      resendInvitations(invitationIds: $invitationIds)
    }
  }
`;
